export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Posiciones de columnas',
	plural_model_name_spanish: 'Posiciones de columnas',
	create_model_name_spanish: 'Nueva Posiciones de columnas',
	text_delete: 'la',
}